export default __webpack_public_path__ + "static/media/100_51335.4196df1e.jpg";